import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "PromptManagement",
  data() {
    return {
      prompts: [],
      apiKeys: [],
      form: {
        name: "",
        description: "",
        prompt: "",
        promptSystem: "",
        promptUser: "",
        shortId: "",
        apiShortId: "",
        module: "",
        action: "",
        shared: false,
        isDefault: false,
        rewriteQuestion: false
      },
      isEditing: false,
      editingId: null,
      deleteDialog: false,
      promptToDelete: null,
      showForm: false,

      // fixe Modulliste
      moduleOptions: [
        { value: "news", title: "News" },
        { value: "poi", title: "POI" },
        { value: "events", title: "Events" },
        { value: "admin", title: "Administration" }
      ],
      moduleActionOptions: {
        news: [
          { value: "rewrite", title: "Texte umschreiben" },
          { value: "check_texts", title: "Texte prüfen" },
          {
            value: "app_push_message_title",
            title: "Push-Nachricht Titel"
          },
          {
            value: "app_push_message_message",
            title: "Push-Nachricht Text"
          }
        ],
        poi: [{ value: "rewrite", title: "Texte umschreiben" }],
        events: [{ value: "rewrite", title: "Texte umschreiben" }],
        admin: [
          {
            value: "color_palette_from_picture",
            title: "Farbpalette aus Bild(ern) generieren"
          },
          {
            value: "color_palette_from_url",
            title: "Farbpalette aus URLs generieren"
          }
        ]
      },
      filters: {
        q: "", // Volltextsuche (Name, Description, Prompt)
        module: "", // Modul-Filter
        apiShortId: "", // API-Key-Filter
        shared: "any" // any | shared | private
      }
    };
  },
  async created() {
    await this.$store.dispatch("getCurrentUser");
    await Promise.all([this.fetchPrompts(), this.fetchKeys()]);
  },
  methods: {
    async fetchPrompts() {
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          { params, headers }
        );
        this.prompts = res.data || [];
      } catch (err) {
        console.error("Failed to fetch prompts:", err);
      }
    },

    async fetchKeys() {
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/keys`,
          { params, headers }
        );
        this.apiKeys = (res.data || []).map(k => ({
          ...k,
          provider: k.provider || "OpenAI" // Fallback
        }));
      } catch (err) {
        console.error("Failed to fetch API keys:", err);
      }
    },

    async addPrompt() {
      if (!this.form.name || !this.form.prompt) return;
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        await axios.post(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          this.form,
          { params, headers }
        );
        await this.resetForm();
        await this.fetchPrompts();
      } catch (err) {
        console.error("Failed to add prompt:", err);
      }
    },

    async editPrompt(prompt) {
      this.form.name = prompt.name || "";
      this.form.description = prompt.description || "";
      this.form.prompt = prompt.prompt || "";
      this.form.promptSystem = prompt.promptSystem || "";
      this.form.promptUser = prompt.promptUser || "";
      this.form.shortId = prompt.shortId || "";
      this.form.shared = !!prompt.shared;
      this.form.isDefault = !!prompt.isDefault;
      this.form.rewriteQuestion = !!prompt.rewriteQuestion;
      this.form.module = prompt.module || "";
      this.form.action = prompt.action || "";
      this.form.apiShortId = prompt.apiShortId || "";
      this.editingId = prompt._id;
      this.isEditing = true;
      this.showForm = true;
      await this.$nextTick();
      this.scrollToPromptForm();
    },

    scrollToPromptForm() {
      const target = this.$refs.promptFormSection;
      if (target?.$el?.scrollIntoView) {
        target.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (target?.scrollIntoView) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },

    async copyPrompt(prompt) {
      await this.resetForm();
      await this.editPrompt(prompt);
      this.form.name = (prompt.name || "") + " (Copy)";
      this.form.shared = false;
      this.form.isDefault = false;
      this.isEditing = false;
      this.showForm = true;
      await this.$nextTick();
      this.scrollToPromptForm();
    },

    async updatePrompt() {
      if (!this.editingId) return;
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        await axios.put(
          `${env.prompts_api_client_url}api/eo-prompt/prompts/${this.editingId}`,
          this.form,
          { params, headers }
        );
        await this.resetForm();
        await this.fetchPrompts();
      } catch (err) {
        console.error("Failed to update prompt:", err);
      }
    },

    async cancelEdit() {
      await this.resetForm();
    },

    async resetForm() {
      this.form = {
        name: "",
        description: "",
        prompt: "",
        promptSystem: "",
        promptUser: "",
        shortId: "",
        apiShortId: "",
        module: "",
        action: "",
        shared: false,
        isDefault: false,
        rewriteQuestion: false
      };
      this.editingId = null;
      this.isEditing = false;
      this.showForm = false;
    },

    async confirmDelete(prompt) {
      this.promptToDelete = prompt;
      this.deleteDialog = true;
    },

    async deletePrompt() {
      try {
        const headers = getTokenHeader();
        const params = { principal_id: this.currentPrincipal };
        await axios.delete(
          `${env.prompts_api_client_url}api/eo-prompt/prompts/${this.promptToDelete._id}`,
          { params, headers }
        );
        this.deleteDialog = false;
        this.promptToDelete = null;
        await this.fetchPrompts();
      } catch (err) {
        console.error("Failed to delete prompt:", err);
      }
    },

    // Hilfen für Anzeige
    moduleLabel(val) {
      const found = this.moduleOptions.find(o => o.value === val);
      return found ? found.title : val || "-";
    },
    apiKeyLabel(shortId) {
      if (!shortId) return "-";
      const k = this.apiKeys.find(x => x.shortId === shortId);
      if (!k) return shortId;
      // Name + Provider für klare Anzeige
      return `${k.name || k.shortId} (${k.provider || "OpenAI"})`;
    },
    hasPromptValue(value) {
      return String(value || "").trim().length > 0;
    },
    truncatePromptText(value, maxLength = 100) {
      const text = String(value || "").trim();
      if (!text) return "";
      if (text.length <= maxLength) return text;
      return `${text.slice(0, maxLength)}...`;
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    filteredPrompts() {
      const q = (this.filters.q || "").toLowerCase();
      const mod = this.filters.module || "";
      const key = this.filters.apiShortId || "";
      const shared = this.filters.shared;

      return (this.prompts || []).filter(p => {
        // shared filter
        if (shared === "shared" && !p.shared) return false;
        if (shared === "private" && p.shared) return false;

        // module filter
        if (mod && (p.module || "") !== mod) return false;

        // api key filter
        if (key && (p.apiShortId || "") !== key) return false;

        // text match
        if (!q) return true;
        const hay = [
          p.name || "",
          p.description || "",
          p.prompt || "",
          p.promptSystem || "",
          p.promptUser || "",
          p.shortId || ""
        ]
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    apiKeyOptions() {
      return (this.apiKeys || []).map(k => ({
        value: k.shortId,
        title: k.name || k.shortId
      }));
    },
    apiKeyFilterItems() {
      return [{ value: "", title: "Alle" }, ...this.apiKeyOptions];
    },
    cModuleActionOptions() {
      const module = this.form?.module;
      return this.moduleActionOptions[module] ?? [];
    }
  },
  watch: {
    currentPrincipal() {
      // bei Principal-Wechsel beides neu laden
      this.fetchPrompts();
      this.fetchKeys();
    }
  }
};
